<template>
  <v-container fluid grid-list-xl fill-height>
    <v-layout justify-center align-center>
      <v-flex xs12 sm8 md4>
        <material-card color="primary" title="Services - Reset Password" text="Please insert your username">
          <v-form ref="resetForm">
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field id="input_username" v-model="resetForm.username" :rules="validators.username" prepend-icon="mdi-account"
                    name="username" label="Username or Email" type="text" />
                </v-flex>

                <v-flex xs6 text-left>
                  <br>
                  <a @click="login">Back to Login</a>
                </v-flex>

                <v-flex xs6 text-right>
                  <v-btn id="button_send" color="primary" :disabled='loading || !resetForm.username' :loading='loading' class="mx-0 font-weight-light"
                    @click="reset">Send</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import validators from '@/utils/validators'
import { resetPass } from '@/api/user'

export default {
  data: () => ({
    loading: false,
    resetForm: {
      username: ''
    },
    validators
  }),

  methods: {
    async reset() {
      this.loading = true
      try {
        await resetPass({ username: this.resetForm.username })
        this.$root.$emit('openSnackbar', { message: 'Password reset requested. Please check your e-mail. ', color: 'success' })
        this.$router.push({ path: '/login' })
      } catch (e) {
        this.$root.$emit('openSnackbar', { message: e.response.data.message, color: 'red' })
      }
      this.$refs.resetForm.reset()
      this.loading = false
    },
    login() {
      this.$router.push({ path: '/login' })
    },
  }
}
</script>
